"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ipBan = require("@/api/ipBan");
var _permission = require("@/utils/permission");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IpBanConfig',
  data: function data() {
    var validatePostAllowlistText = function validatePostAllowlistText(rule, value, callback) {
      var list = Array.from(new Set((value || '').split(/\r?\n/).map(function (s) {
        return s.trim();
      }).filter(Boolean)));
      if (list.length > 100) return callback(new Error('POST 白名单最多支持 100 条 URI'));
      var invalid = list.find(function (s) {
        return !s.startsWith('/');
      });
      if (invalid) return callback(new Error('URI 必须以 / 开头'));
      var oversize = list.find(function (s) {
        return s.length > 255;
      });
      if (oversize) return callback(new Error('URI 长度不能超过 255 个字符'));
      callback();
    };
    return {
      loading: false,
      saving: false,
      form: {
        isEnabled: 1,
        banStrategy: 'BLOCK_ALL',
        globalRateLimit: 200,
        banTtlFirst: 3600,
        banTtlSecond: 86400,
        banTtlMax: 259200,
        postAllowlistText: ''
      },
      rules: {
        globalRateLimit: [{
          required: true,
          message: '请输入全局限流阈值',
          trigger: 'blur'
        }],
        banTtlFirst: [{
          required: true,
          message: '请输入第1次封禁时长',
          trigger: 'blur'
        }],
        banTtlSecond: [{
          required: true,
          message: '请输入第2次封禁时长',
          trigger: 'blur'
        }],
        banTtlMax: [{
          required: true,
          message: '请输入第3次封禁时长',
          trigger: 'blur'
        }],
        postAllowlistText: [{
          validator: validatePostAllowlistText,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    postAllowlistCount: function postAllowlistCount() {
      return Array.from(new Set((this.form.postAllowlistText || '').split(/\r?\n/).map(function (s) {
        return s.trim();
      }).filter(Boolean))).length;
    }
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:ip:ban:config:info'])) this.loadConfig();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    loadConfig: function loadConfig() {
      var _this = this;
      this.loading = true;
      (0, _ipBan.ipBanConfigInfo)().then(function (res) {
        _this.form = _objectSpread(_objectSpread(_objectSpread({}, _this.form), res), {}, {
          postAllowlistText: Array.isArray(res.postAllowlist) ? res.postAllowlist.join('\n') : ''
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.configForm.validate(function (valid) {
        if (!valid) return;
        var postAllowlist = Array.from(new Set((_this2.form.postAllowlistText || '').split(/\r?\n/).map(function (s) {
          return s.trim();
        }).filter(Boolean)));
        var payload = _objectSpread(_objectSpread({}, _this2.form), {}, {
          postAllowlist: postAllowlist
        });
        delete payload.postAllowlistText;
        _this2.saving = true;
        (0, _ipBan.ipBanConfigUpdate)(payload).then(function () {
          _this2.form.postAllowlistText = postAllowlist.join('\n');
          _this2.$message.success('保存成功');
        }).finally(function () {
          _this2.saving = false;
        });
      });
    },
    formatSeconds: function formatSeconds(seconds) {
      if (!seconds) return '';
      if (seconds < 60) return "\u7EA6 ".concat(seconds, " \u79D2");
      if (seconds < 3600) return "\u7EA6 ".concat(Math.round(seconds / 60), " \u5206\u949F");
      if (seconds < 86400) return "\u7EA6 ".concat(Math.round(seconds / 3600), " \u5C0F\u65F6");
      return "\u7EA6 ".concat(Math.round(seconds / 86400), " \u5929");
    }
  }
};